import { useEffect } from 'react';
import AnimatedSection from '../base/AnimatedSection';

const InstantBooking = () => {
  useEffect(() => {
    // Load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <AnimatedSection className="bg-gradient-to-br from-[#708474]/10 to-[#a4ae9e]/10 rounded-2xl p-8">
      <div className="text-center mb-8">
        <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
          <i className="ri-calendar-check-line text-4xl text-[#708474]"></i>
        </div>
        <h3 className="text-2xl font-bold text-[#34444b] mb-2">Book Your Call Instantly</h3>
        <p className="text-[#73807c]">No back-and-forth emails. Pick your time and let's talk.</p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div 
          className="calendly-inline-widget" 
          data-url="https://calendly.com/sebastian-thepilotcopy/30min" 
          style={{ minWidth: '320px', height: '700px' }}
        ></div>
      </div>
    </AnimatedSection>
  );
};

export default InstantBooking;
